import Image from 'next/image'
import { styled } from '@/src/stitches.config'
import Link from 'next/link'
import { clickedRelatedItemEvent } from '@/src/common/utilities/gtag'

const StyledWrapper = styled('div', {
    mt: 15,
    width: 200,
    maxWidth: '48%',
    '@sm': {
        width: 120,
        maxWidth: '100%',
    },
    '& img': {
        width: '100%',
        height: 'auto',
        boxShadow: 'gray 0px 1px 10px -1px',
        br: 10,
        aspectRatio: '3/2',
    },
})

type TItemProps = {
    image: string
    name: string
    url: string
}

const RelatedItem = ({ image, name, url }: TItemProps) => {
    return (
        <StyledWrapper data-testid={'related-brand'}>
            <Link
                href={url}
                aria-label={`${name} image and link`}
                onClick={() => clickedRelatedItemEvent('related brand', name)}
            >
                <Image src={image} alt={name} width={256} height={162} />
            </Link>
        </StyledWrapper>
    )
}

export default RelatedItem
